import { configureStore } from "@reduxjs/toolkit";

import authUserReducer from "./reduxSlice/sliceAuthUser/AuthUser";
import bookingReducer from "./reduxSlice/sliceBooking/Booking.js";
import forgetReducer from "./reduxSlice/sliceForgetPassword/Forget.js";
import allUserSlice from "./reduxSlice/sliceAllUser/AllUser.js";

export const store = configureStore({
  reducer: {
    auth: authUserReducer,
    booking: bookingReducer,
    forget: forgetReducer,
    alluser: allUserSlice,
  },
});
